<template src="./OrkHomeGallery.html"></template>

<script>

import {
  SfImage,
  SfButton
} from '@storefront-ui/vue';


import Api from "@/api/Api";
import OrkLoader from "@/components/Ork/OrkLoader";

export default {
  name: 'OrkHomeGallery',
  components: {
    OrkLoader,
    SfImage,
    SfButton,
  },

  data() {
    return {
      index: null,
      gallery: [],
      loading: false
    };
  },

  created() {
    this.getHomeSlider()
  },

  methods: {
    getHomeSlider() {
      this.loading = true
      Api.marketing.getHomeSlider().then((data) => {
        this.gallery[0] = data.sliders[0]

      }).catch((e) => {


      }).finally(()=>{
        this.loading = false
      })
    }

  }
};
</script>


<style lang='scss' scoped src="./OrkHomeGallery.scss"></style>